import React from 'react';
import type ProjectSettingsProformaJiraFormBuilderType from '@atlassian/jira-spa-apps-project-settings-proforma-jira-form-builder/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsProformaJiraFormBuilder = lazyForPaint<
	typeof ProjectSettingsProformaJiraFormBuilderType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-proforma-jira-form-builder", jiraSpaEntry: "async-project-settings-proforma-jira-form-builder" */ '@atlassian/jira-spa-apps-project-settings-proforma-jira-form-builder'
		),
);

const AsyncProjectSettingsProformaJiraFormBuilder = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsProformaJiraFormBuilder}
		pageId="project-settings-proforma-jira-form-builder"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsProformaJiraFormBuilder;
